/**
 * @fileoverview
 * Summary Cards Component - Display summary cards in grid
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, Input, ChangeDetectionStrategy, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { formatInrDigits, formatInrNumber } from '@core/utils';

export interface SummaryCard {
  title: string;
  value: string | number;
  currency?: string;
}

@Component({
  selector: 'app-summary-cards',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './summary-cards.component.html',
  styleUrl: './summary-cards.component.css',
})
export class SummaryCardsComponent {
  @Input() cards: SummaryCard[] = [];
  @Input() gridColumns: '1' | '2' | '3' | '4' | '6' = '4';

  formatValue(value: string | number, currency?: string): string {
    if (typeof value === 'number') {
      return currency ? `${currency} ${formatInrDigits(value)}` : formatInrNumber(value);
    }
    return value;
  }

  gridClass = computed(() => {
    const gridMap: Record<string, string> = {
      '1': 'grid-cols-1',
      '2': 'grid-cols-1 sm:grid-cols-2',
      '3': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
      '4': 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
      '6': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6',
    };
    return gridMap[this.gridColumns] || gridMap['4'];
  });
}

